import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';

import { Router } from '@angular/router';
import { contentHeaders } from '../Core/Headers';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {Configuration} from '../Shared/Constants/index';
import { tokenNotExpired } from 'angular2-jwt';
import {AuthHttp} from 'angular2-jwt';
import { environment } from '../../environments/environment';
import { SeedDataService } from './seeddata.service';


@Injectable()
export class AuthenticationService {
readonly rootUrl = environment.apiEndPoint;
    private actionUrl: string;
    private headers: Headers;
    private apiUrl: string;
    private readonly APIEndPoint: any = environment.apiEndPoint;

    constructor(private http: Http, private router: Router, private seedDataService: SeedDataService) {
        
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');
    }

    login(Email: string, Password: string,RememberMe : boolean) {

        let body = JSON.stringify({ Email, Password, RememberMe});

        return this.http.post(this.APIEndPoint + '/api/UserService/AuthenticateUser', body, { headers: this.headers })
            .map((response: Response) => {
                // login successful if there's a jwt token in the response

                return response.json();
                
            });
    }
    forgotpassword(Email: string) {
       
        let body = JSON.stringify({ Email});
        return this.http.post(this.APIEndPoint + '/api/UserService/ForgotPassword', body, { headers: this.headers })
            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                 return response.json();

            });
    }
    updatePassword(user: any) {
        console.log('user to save is: ', user);
        return this.http.post(this.APIEndPoint + '/api/UserService/UpdatePassword', user, { headers: this.headers })
            .map((response: Response) => {
                // login successful if there's a jwt token in the response

                return response.json();

            });
    }

    getUserByResetPasswordLink(resetGuid: string) {
        this.apiUrl = this.APIEndPoint + "/api/UserService/GetUserByResetPasswordLink?resetGuid=" + resetGuid;
        return this.http.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            //return this.renamePropertyNames(JSON.stringify(data));
            return data;
        });
        
    }

	GetPagesByUserID(userId: any) {
        
        this.apiUrl = this.APIEndPoint + "/api/Pages/GetPagesByUserID?UserID=" + userId;
        return this.http.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            //return this.renamePropertyNames(JSON.stringify(data));
            
            return data;
            
        });
        
    }
	SecureLogin(token: any) {
    
        this.apiUrl = this.APIEndPoint + "/Login/Login";
       
        this.headers.append('Authorization', token);
        return this.http.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            //return this.renamePropertyNames(JSON.stringify(data));
            return data;
        });
    }

    loginTeam() {
        var form: any = document.getElementById("frm");
        setTimeout(() => {

            form.submit();
        }, 1000);
    }
    logoutTeam() {

        var form: any = document.getElementById("frmlogout");
        form.submit();

    }


    logout() {
        // remove user from local storage to log user out

        if (this.seedDataService && this.seedDataService.clearCache) {
            this.seedDataService.clearCache();
            if (this.seedDataService.clearLegacyLocalStorageCache) {
                this.seedDataService.clearLegacyLocalStorageCache();
            }
        }

        window.localStorage.clear();
        window.localStorage.removeItem('currentUser');
        window.localStorage.removeItem('pagedetails')
        window.localStorage.removeItem('id_token');

       // this.logoutTeam();
     // this.AuthenticationServicelogout();
     window.location.href = '#/login?logout=1';
        //this.router.navigateByUrl('/login');

    }

    AuthenticationServicelogout() {

       
        return this.http.post(this.APIEndPoint + '/api/UserService/logout', { headers: this.headers })
            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                return response.json();

            });
    }
  loginExternal(Email: string, token: any) {
        let body = JSON.stringify({ Email});
        
        return this.http.post(this.rootUrl + '/api/UserService/AuthenticateExternalUser?providerToken=' +token, body, { headers: this.headers })
            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                return response.json();
            });
    }    
}

//@Injectable()
//export class AuthenticationService {

//    lock = new Auth0Lock('YOUR-AUTH0-CLIENT-ID', 'YOUR-AUTH0-DOMAIN.auth0.com');

//    constructor(private router: Router) {
//        this.lock.on('authenticated', (authResult: any) => {
//            localStorage.setItem('id_token', authResult.idToken);

//            this.lock.getProfile(authResult.idToken, (error: any, profile: any) => {
//                if (error) {
//                    console.log(error);
//                }

//                localStorage.setItem('profile', JSON.stringify(profile));
//                this.router.navigateByUrl('/home');
//            });

//            this.lock.hide();
//        });
//    }

//    login() {
//        this.lock.show();
//    }

//    logout() {
//        // To log out, just remove the token and profile
//        // from local storage
//        localStorage.removeItem('profile');
//        localStorage.removeItem('id_token');

//        // Send the user back to the dashboard after logout
//        this.router.navigateByUrl('/login');
//    }

//    loggedIn() {
//        return tokenNotExpired();
//    }
//}





// WEBPACK FOOTER //
// ./src/app/Services/authentication.service.ts